import {
  AddCaseToPallet,
  AddProductsToCaseResponse,
  BuildPalletRequest,
  GetPalletCasesResponse,
  MovePalletResponse,
  PalletCloseResponse,
  PRBEResponse,
  ScanCaseResponse,
  ScanLocatinResponse,
  ScanPalletResponse,
} from 'types';
import { getRequestWithPRBE, postRequestWithPRBE, putRequestWithPRBE } from '.';

export const getProductsByCaseId = async (caseId: string): Promise<ScanCaseResponse> =>
  getRequestWithPRBE(`rtv/wms/case-products/${caseId}`);

export const addProductToCase = async (
  caseId: string,
  productId: string
): Promise<AddProductsToCaseResponse> =>
  putRequestWithPRBE(`rtv/wms/product-add/${productId}/carton/${caseId}`);

export const removeProductFromCase = async (
  caseId: string,
  productId: string
): Promise<AddProductsToCaseResponse> =>
  putRequestWithPRBE(`rtv/wms/product-remove/${productId}/carton/${caseId}`);

export const scanPallet = async (palletId: string): Promise<ScanPalletResponse> =>
  getRequestWithPRBE(`rtv/wms/pallet/${palletId}`);

export const buildPallet = async (payload: BuildPalletRequest): Promise<PRBEResponse> =>
  postRequestWithPRBE('rtv/wms/pallet-build', payload);

export const addCaseToPallet = async (palletId: string, caseId: string): Promise<AddCaseToPallet> =>
  putRequestWithPRBE(`rtv/wms/carton-add/${palletId}/carton/${caseId}`);

export const removeCaseFromPallet = async (
  palletId: string,
  caseId: string
): Promise<AddCaseToPallet> =>
  putRequestWithPRBE(`rtv/wms/carton-remove/${palletId}/carton/${caseId}`);

export const getPalletCases = async (palletId: string): Promise<GetPalletCasesResponse> =>
  getRequestWithPRBE(`rtv/wms/pallet-cases/${palletId}`);

export const addPalletWeight = async (
  palletId: string,
  weightKg: number
): Promise<GetPalletCasesResponse> =>
  putRequestWithPRBE(`rtv/wms/pallet-weight/${palletId}/weight/${weightKg}`);

export const scanLocation = async (locationId: string): Promise<ScanLocatinResponse> =>
  getRequestWithPRBE(`rtv/wms/locations/${locationId}`);

export const movePallet = async (
  palletId: string,
  locationId: string
): Promise<MovePalletResponse> =>
  putRequestWithPRBE(`rtv/wms/pallet-destination/${palletId}/update/${locationId}`);

export const closePallet = async (
  palletId: string,
  weightKg: number,
  locationId: string
): Promise<PalletCloseResponse> =>
  postRequestWithPRBE('rtv/wms/pallet-close', {
    pallet_id: palletId,
    weight_kg: weightKg,
    location_id: locationId,
  });
